const s = (o) => {
  const a = o == null ? void 0 : o.type;
  return (a == null ? void 0 : a.displayName) || (a == null ? void 0 : a.name) || (a == null ? void 0 : a.value) || "Unknown";
};
export {
  s as getComponentDisplayName
};
//# sourceMappingURL=index.es726.js.map
